import { CalendarDate } from "@tournated-com/ui";

import { ClubReference } from "@/types/club.types";
import { AvatarFields, CountryCode } from "@/types/common.types";
import { SportRef } from "@/types/sport.types";

/**
 * REST-backed row for the league-athletes list (`GET /dashboard/v1/leagues/:id/athletes`).
 * Flat scalars plus reference relations — `tournaments` is the count of confirmed
 * tournaments the athlete has entered in this specific league.
 */
export type LeagueAthleteListItem = AvatarFields & {
  id: string;
  /**
   * Temporary numeric DB id, exposed only to bridge the public-facing athlete
   * profile URL (`{clientUrl}/profile/{internalId}`) that still takes the
   * numeric id. Deprecated on the wire; remove once the client accepts
   * publicIds.
   */
  internalId: number;
  tournatedTag: string;
  name: string;
  surname: string;
  nation: CountryCode | null;
  birthDate: CalendarDate | null;
  sports: SportRef[];
  clubs: ClubReference[];
  tournaments: number;
};

export const LeagueAthletesTableColumnValues = [
  "id",
  "user",
  "age",
  "sports",
  "clubs",
  "tournaments",
] as const;

export type LeagueAthletesTableColumn = (typeof LeagueAthletesTableColumnValues)[number];

export const LeagueAthleteExportColumnValues = [
  "name",
  "surname",
  "email",
  "tournatedTag",
  "nation",
  "birthDate",
  "sports",
  "clubs",
  "tournamentsCount",
] as const;

export type LeagueAthleteExportColumn = (typeof LeagueAthleteExportColumnValues)[number];
